import { render, staticRenderFns } from "./RTextbox.vue?vue&type=template&id=0f46ed64&scoped=true"
import script from "./RTextbox.vue?vue&type=script&lang=js"
export * from "./RTextbox.vue?vue&type=script&lang=js"
import style0 from "./RTextbox.vue?vue&type=style&index=0&id=0f46ed64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46ed64",
  null
  
)

export default component.exports